export * from './Component_TagEditor.js';
//# sourceMappingURL=index.js.map